module.exports = require("userful-chronos-app-common-js/dist/models/mapping/MappingGroups");